import { render, staticRenderFns } from "./MewAlert.vue?vue&type=template&id=f1443ffa&scoped=true"
import script from "./MewAlert.vue?vue&type=script&lang=js"
export * from "./MewAlert.vue?vue&type=script&lang=js"
import style0 from "./MewAlert.vue?vue&type=style&index=0&id=f1443ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1443ffa",
  null
  
)

export default component.exports